import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { cancelButton, primaryButton } from "./styles";

type Props = {
  open: boolean;
  name: string;
  busy: boolean;
  error: string;
  onCancel: () => void;
  onConfirm: (reason: string) => void;
};

export function NotApproveDialog({ open, name, busy, error, onCancel, onConfirm }: Readonly<Props>) {
  const [reason, setReason] = useState("");
  useEffect(() => {
    if (!open) setReason("");
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && !busy && onCancel()}>
      <DialogContent className="max-w-lg p-0 gap-0 bg-white-A700 rounded-lg">
        <DialogHeader className="px-8 pt-8 pb-4 text-left gap-2">
          <DialogTitle className="text-xl font-bold text-black-label">
            Not approve: {name}
          </DialogTitle>
          <DialogDescription className="text-base text-[#4B5160]">
            Documents are retained. The applicant sees a &quot;not yet online&quot; state with a contact route.
          </DialogDescription>
        </DialogHeader>
        <div className="px-8 pb-6 flex flex-col gap-3">
          <label className="flex flex-col gap-1.5">
            <span className="text-sm font-medium">
              Reason <span aria-hidden>*</span>
            </span>
            <Textarea
              // Tailwind's ring-* draws nothing on a field here (see .field-focus-ring in index.css).
              className="border-gray-500 field-focus-ring"
              aria-required
              value={reason}
              maxLength={1000}
              onChange={(e) => setReason(e.target.value)}
            />
          </label>
          {error && <p className="text-sm text-red-600" role="alert">{error}</p>}
        </div>
        <DialogFooter className="px-8 py-5 flex-row justify-end gap-2.5 rounded-b-lg bg-gray-button-gray-lite">
          <button type="button" className={cancelButton} disabled={busy} onClick={onCancel}>
            Cancel
          </button>
          <button
            type="button"
            className={primaryButton}
            disabled={!reason.trim() || busy}
            onClick={() => onConfirm(reason.trim())}
          >
            {busy ? "Saving…" : "Confirm"}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
